import React from 'react';
import Keycloak from 'keycloak-js';
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { KEYCLOAK } from '../variables/keycloak-const';
import { keycloakJsonConfigFile } from '../config';
import { keycloakService } from '../services/keycloak-service';
import { UserService } from '../services/user-service';
import { DataService } from '../services/data-service';
import { authRequired } from "../config";
import { NotificationService, NOTIFICATION_VARIANT } from "../services/notification-service";

const keycloak = new Keycloak(keycloakJsonConfigFile);

const keycloakInitConfig = {
  onLoad: "check-sso",
  checkLoginIframe: false
};

try{
  let referer = sessionStorage.getItem('referer');

  sessionStorage.setItem('referer', 'auth/realms');
  
}catch(error) {
  //NotificationService.send(error && error.message, NOTIFICATION_VARIANT.ERROR);
  console.log(error && error.message);
}

class PersistedApp extends React.Component {
  
  constructor() {
    super();
    this.refreshTokenSignal = keycloakService
      .getRefreshTokenSignal()
      .subscribe(() => keycloak.updateToken(-1));

    this.logoutSignal = keycloakService
      .getLogoutSignal()
      .subscribe(() => keycloak.logout());
  }

  onKeycloakEvent = (event, error) => {
    console.log('onKeycloakEvent', event, error);
    switch (event) {
      case KEYCLOAK.EVENT.AUTH_SUCCESS: {
        const captureRole = (keycloak.tokenParsed.roles || [])
            .filter((role) => role.includes('capture'));
            
        if(captureRole.length > 0){
            const index = captureRole.indexOf("mobile_capture");
            if (index > -1) {
                captureRole.splice(index, 1);
            }
        }
        
        let captureRoleString = captureRole.toString();
        
        UserService.setRoles(keycloak.tokenParsed.roles);
        UserService.setUserId(keycloak.tokenParsed.preferred_username);
        UserService.setCaptureRole(captureRoleString);

        // ✅ emitir el payload ya enriquecido desde aquí
        // toda la info está disponible en este momento
        DataService.setPayloadToRetrieveFormInfo({
            USERID: keycloak.tokenParsed.preferred_username,
            ROLEID: captureRoleString, // ✅ string, no array
            CLIENTID: "1",
            IDCOMBO1: "16",
            IDCOMBO2: "30",
            IDCOMBO3: "61",
            SUBCLIENTID: "1"
        });
        break;
      }
    }

    if(authRequired) {
      try{
        let referer = JSON.parse(sessionStorage.getItem('referer')) || [];
        console.log(referer);
        let isReferedByKeycloak = referer.some( item => item.includes('auth/realms'));
        
        if(!isReferedByKeycloak) {
          console.log("entro a cerrar sesión");
          keycloakService.logout();
        }
      }
      catch(error) {
        //NotificationService.send(error && error.message, NOTIFICATION_VARIANT.ERROR);
        console.log(error && error.message);
      }
    }
    
  };

  onKeycloakTokens = ({ idToken, refreshToken, token }) => {
    keycloakService.setToken(token);
    keycloakService.sendRefreshedTokenSignal();
  };

  componentWillUnmount() {
    this.refreshTokenSignal.unsubscribe();
    this.logoutSignal.unsubscribe();
  }

  render() {
    return (
      <ReactKeycloakProvider authClient={keycloak}
        keycloak={keycloak}
        onTokens={this.onKeycloakTokens}
        onEvent={this.onKeycloakEvent}
        initConfig={keycloakInitConfig}
      >
        {this.props.children}
      </ReactKeycloakProvider>
    );
  }
}

export default PersistedApp;
